// Copyright (c) 2021. Sendanor <info@sendanor.fi>. All rights reserved.

import * as React from "react";
import "./PipelineRun.scss";
import PipelineModel from "../../../../nor/pipeline/types/PipelineModel";
import ControllerStateDTO
    from "../../../../nor/pipeline/controllers/types/ControllerStateDTO";
import TextAreaField from "../../../../nor/ui/components/fields/textArea/TextAreaField";
import FormAppClassName from "../../../../constants/FormAppClassName";
import PipelineControllerState from "./state/PipelineControllerState";
import Button from "../../../../nor/ui/components/button/Button";
import Icon from "../../../../nor/ui/components/icon/Icon";
import { NewWindowIcon } from "../../../../assets/icon";
import { VoidCallback } from "../../../../nor/ts/interfaces/callbacks";
import PipelineRunMonitorModal from "../../../../modals/PipelineRunMonitorModal";
import LogService from "../../../../nor/ts/LogService";

const LOG = LogService.createLogger('PipelineRun');

export interface PipelineRunProps {

    readonly className      ?: string;
    readonly pipelineId      : string;
    readonly pipelineRunId   : string;
    readonly pipelineModel   : PipelineModel;
    readonly pipelineState   : ControllerStateDTO;

}

export interface PipelineRunState {
}

/**
 * Component to display PipelineRun models
 */
export class PipelineRun extends React.Component<PipelineRunProps, PipelineRunState> {

    public static defaultProps: Partial<PipelineRunProps> = {};
    private readonly _openRunMonitorCallback : VoidCallback;

    public constructor (props: PipelineRunProps) {
        super(props);
        this._openRunMonitorCallback = this._onOpenRunMonitor.bind(this);
    }

    public render () {

        return (
            <div className={FormAppClassName.PIPELINE_RUN + ' ' + (this.props.className ?? '')}>

                <TextAreaField value={JSON.stringify(this.props.pipelineModel, null, 2)} />

                <div className={FormAppClassName.PIPELINE_RUN+'-state'}>

                    <h4 className={FormAppClassName.PIPELINE_RUN+'-state-title'}>State</h4>

                    <PipelineControllerState
                        className={FormAppClassName.PIPELINE_RUN+'-state-value'}
                        item={this.props.pipelineState}
                    />

                    <div className={FormAppClassName.PIPELINE_RUN+'-state-buttons'}>
                        <Button
                            click={this._openRunMonitorCallback}
                        ><Icon><NewWindowIcon /></Icon></Button>
                    </div>

                </div>

            </div>
        );

    }

    private _onOpenRunMonitor () {

        const pipelineId = this.props.pipelineId;
        const pipelineRunId = this.props.pipelineRunId;

        if (!pipelineId) {
            LOG.error(`No pipeline ID: `, pipelineId);
            return;
        }

        if (!pipelineRunId) {
            LOG.error(`No pipeline run ID: `, pipelineRunId);
            return;
        }

        PipelineRunMonitorModal.openModal(
            pipelineId,
            pipelineRunId
        );

    }

}

export default PipelineRun;
